import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import appRoutes from '../../../../../routes/appRoutes';
import CashbackPresenter from '../../../../../presenters/CashbackPresenter';
import FormHeader from '../../../../../components/FormHeader';

const Header = (props) => {
  const { cashback, onDeleteDialogOpen, onEditCashbackStateDialogOpen } = props;
  return (
    <FormHeader title="Cashback Details">
      {CashbackPresenter.isEditable(cashback) && (
        <Link
          to={appRoutes.cashbackEditPath(CashbackPresenter.id(cashback))}
          className="button -in-group"
        >
          Edit
        </Link>
      )}
      {!CashbackPresenter.isSpent(cashback) && (
        <div
          id="deleteCashback"
          className="button delete -in-group"
          onClick={onDeleteDialogOpen}
        >
          Delete
        </div>
      )}
      {CashbackPresenter.canChangeState(cashback) && (
        <button
          className="button -in-group"
          onClick={onEditCashbackStateDialogOpen}
        >
          Change State
        </button>
      )}
    </FormHeader>
  );
};

export default Header;

Header.propTypes = {
  cashback: CashbackPresenter.shape().isRequired,
  onDeleteDialogOpen: PropTypes.func.isRequired,
  onEditCashbackStateDialogOpen: PropTypes.func.isRequired,
};
